import request, { appendApiUrl } from '@/utils/request'
import { deleteEmpty } from './common.js'
import { getUvid } from '../utils/uvid'
import { isXiaomiDevice } from '../utils/utils'

export const getCloudControlPopups = (options) => {
  const params = {
    ...options,
    uvid: getUvid(),
    miDevice: isXiaomiDevice() ? 0 : 1,
  }
  return request.postJson(
    {
      url: appendApiUrl('/config/query/popups'),
      data: { ...deleteEmpty(params) },
    },
    {
      showLoading: false,
      showErrorToast: false,
    },
    true
  )
}
